import Swiper, { Navigation, Pagination } from 'swiper';

export const initHomePageSlider = () => {
    new Swiper('.hero-slider .swiper-container', {
        modules: [Navigation, Pagination],
        autoplay: {
            delay: 5000,
        },
        speed: 400,
        loop: true,
        effect: 'fade',
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        paginationClickable: true,
        grabCursor: true,
        navigation: {
            nextEl: '.hero-slider__nav-button--next',
            prevEl: '.hero-slider__nav-button--prev',
        },
    });
};

export const initEmployeeSlider = () => {

    const swiper = new Swiper('.swiper', {
        modules: [Navigation],
        // Optional parameters
        //direction: 'vertical',
        loop: true,

        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

    });
};

export const initHeroSlider = () => {


};

export const initGalleryElementCarousel1 = () => {
	document.querySelectorAll('.js-gallery-element-carousel1').forEach(function (carousel) {
		new Swiper(carousel, {
			speed: 400,
			slidesPerView: 1,
			nextButton: carousel.parentNode.querySelector('.js-gallery-element-carousel1-next'),
			prevButton: carousel.parentNode.querySelector('.js-gallery-element-carousel1-prev'),
		});
	});
};

export const initGalleryElementCarousel2 = () => {
	document.querySelectorAll('.js-gallery-element-carousel2').forEach(function (carousel) {
		new Swiper(carousel, {
			speed: 400,
			spaceBetween: 8,
			slidesPerView: 2,
			nextButton: carousel.parentNode.querySelector('.js-gallery-element-carousel2-next'),
			prevButton: carousel.parentNode.querySelector('.js-gallery-element-carousel2-prev'),
			breakpoints: {
				639: {
					slidesPerView: 3
				},
				1023: {
					slidesPerView: 4
				}
			}
		});
	});
};


export const initInstagramCarousel = () => {
    document.querySelectorAll('.js-insta-gallery').forEach(function (carousel) {
        new Swiper(carousel, {
            speed: 400,
            spaceBetween: 8,
            slidesPerView: 2.5,
            breakpoints: {
                639: {
                    slidesPerView: 3.5
                },
                1023: {
                    slidesPerView: 4.5
                }
            }
        });
    });
};
